import { graphql } from 'react-relay';

import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';

import type {
	useIsDataClassificationEnabledForOrgQuery$data,
	useIsDataClassificationEnabledForOrgQuery$variables,
} from './__generated__/useIsDataClassificationEnabledForOrgQuery.graphql.ts';

const UseIsDataClassificationEnabledForOrgQuery = graphql`
	query useIsDataClassificationEnabledForOrgQuery {
		isDataClassificationEnabled
	}
`;

// hook to determine if data classification is enabled for org
export const useIsDataClassificationEnabledForOrg = ({ skip = false }: { skip?: boolean } = {}) => {
	const { data, error, loading } = useQueryInterop<
		useIsDataClassificationEnabledForOrgQuery$data,
		useIsDataClassificationEnabledForOrgQuery$variables
	>(UseIsDataClassificationEnabledForOrgQuery, {
		context: { single: true },
		skip,
	});

	const isEnabled = Boolean(data?.isDataClassificationEnabled);

	return { isEnabled, error, loading };
};
